export const convertPaceToSpeedKmPerHours = (paceMinPerKm: number): number => {
    const speedKmPerMin = 1 / paceMinPerKm;
    return speedKmPerMin * 60;
}
export const convertPaceToSpeedMetersPerSeconds = (paceMinPerKm: number): number => {
    const speedKmPerMin = 1 / paceMinPerKm;
    return speedKmPerMin * 1000 / 60;
}